import { render, staticRenderFns } from "./DataStateComponent.vue?vue&type=template&id=1531fc2a&"
import script from "./DataStateComponent.vue?vue&type=script&lang=js&"
export * from "./DataStateComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataStateComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports